import { storeToRefs } from 'pinia';
import { useClient } from './useClient';
import type { components } from '@/constants/schema';
import { useAuthStore } from '@/stores/useAuthStore';
import getCookie from '@/utils/getCookie';
import type { NullAway } from '@/types/NullAway';
import { useAnalytics } from './useAnalytics';

export default () => {
  const { client } = useClient();
  const authStore = useAuthStore();
  const { csrfToken } = storeToRefs(authStore);
  const { track } = useAnalytics();

  async function register(body: NullAway<components['schemas']['RegisterRequest']>) {
    const { data, error } = await client.users_register_create(body);
    if (!error) track('signup');

    return { data, error };
  }

  async function login(body: components['schemas']['LoginRequest']) {
    const { data, error } = await client.users_login_create(body);
    if (!error) track('login');

    return { data, error };
  }

  async function logout() {
    const { data, error } = await client.users_logout_create();

    return { data, error };
  }

  async function registerConfirm(body: components['schemas']['RegistrationConfirmRequest']) {
    const { data, error } = await client.users_register_confirm_create(body);
    if (!error) track('signup-confirmed');

    return { data, error };
  }

  async function passwordReset(body: components['schemas']['PasswordResetRequest']) {
    const { data, error } = await client.users_password_reset_create(body);

    return { data, error };
  }

  async function passwordResetConfirm(body: components['schemas']['PasswordResetConfirmRequest']) {
    const { data, error } = await client.users_password_reset_confirm_create(body);

    return { data, error };
  }

  async function changePassword(body: components['schemas']['ChangePasswordRequest']) {
    const { data, error } = await client.users_change_password_create(body);

    return { data, error };
  }

  async function setCsrfToken() {
    const { data, error } = await client.users_csrf_retrieve();
    csrfToken.value = getCookie('csrftoken');

    return { data, error };
  }

  return {
    register,
    registerConfirm,
    login,
    logout,
    passwordReset,
    passwordResetConfirm,
    changePassword,
    setCsrfToken,
  };
};
